import ArrowDownDashed from '@/assets/icons/arrow-down-dashed.svg'
import LocationRedIcon from '@/assets/icons/location-red.svg'

export const Separator = () => {
  return (
    <div className='relative h-full w-6'>
      <div className='absolute top-1/2 z-30 -ms-1 flex w-1 -translate-y-1/2 flex-col items-center justify-center gap-1 ltr:left-4 rtl:right-4'>
        <span className='flex h-6 w-6 items-center justify-center'>
          <span className='mt-3 h-3 w-3 rounded-full bg-red-50'></span>
        </span>
        <span className='inline-block h-7'>
          <ArrowDownDashed />
        </span>
        <span className='flex h-6 items-center justify-center'>
          <LocationRedIcon className='mb-2 inline-block h-4 w-4' />
        </span>
      </div>
    </div>
  )
}
